import {
  EXTEND_FREE_LICENSE,
  EXTEND_FREE_LICENSE_SUCCESSFUL,
  EXTEND_FREE_LICENSE_FAILED,

  CLEAR_ALL_FREE_LICENSE_MESSAGES,
  CLEAR_ALL_FREE_LICENSE_MESSAGES_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  isExtendingFreeLicense: false,
  extendFreeLicenseMessage: null,
  extendFreeLicenseError: null,
};

const freeLicense = (state = initialState, action) => {
  console.log("Action Type :: ", action.type);
  switch (action.type) {
    case EXTEND_FREE_LICENSE:
      state = {
        ...state,
        isExtendingFreeLicense: true,
        extendFreeLicenseMessage: null,
        extendFreeLicenseError: null,
      };
      break;
    case EXTEND_FREE_LICENSE_SUCCESSFUL:
      state= {
        ...state,
        isExtendingFreeLicense: false,
        extendFreeLicenseMessage: action.payload.extendLicenseSuccessData.message,
      };
      break;
    case EXTEND_FREE_LICENSE_FAILED:
        state= {
          ...state,
          isExtendingFreeLicense: false,
          extendFreeLicenseError: action.payload.extendLicenseFailureData.message,  
        };
        break;      
    case CLEAR_ALL_FREE_LICENSE_MESSAGES_SUCCESSFUL:
      state= {
        ...state,
        isExtendingFreeLicense: false,
        extendFreeLicenseMessage: null,
        extendFreeLicenseError: null,
      };
      break;
    default:
        return state;
  }
  return state;
}

export default freeLicense;

